import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const IS_CASINO_FUN_MODE_DISABLED =
  !SpringConfigs.CASINO_FUN_MODE ||
  SpringConfigs.CASINO_DISABLE_FUN_MODE_FOR_NOT_AUTHORIZED_USERS;
